<template>
    <div>
        <modal class="announcement" :display="modalStatus.bizAnnouncement" @modalStatus="closeModal" >
            <h1>公告訊息</h1>
            <div class="announcement-wrap">
                <div class="list">
                    <div class="item" v-for="(item, index) in list" :key="index">
                        <div class="content" v-html="item.content.split('\n').join('<br>')">
                        </div>
                        <div class="date">
                            {{getFormatDateTime(item.announceDate)}}
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import RentSwitch from '@/components/widge/RentSwitch.vue';
import { mapGetters } from 'vuex'

import { 
    apiBizAnnouncementList
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            list: []
        }
    },
    mounted () {
        this.getAnnouncementList()
    },
    methods: {
        getAnnouncementList: function () {
            apiBizAnnouncementList()
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.list = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        closeModal: function () {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizAnnouncement'})
        },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    #modal.announcement{
        .error{
            right: 0px;
            top: 7px;
        }
        .modal-content{
            width: 624px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 15px;
                    font-size: 24px;
                }
                .announcement-wrap{
                    padding: 0 32px 32px 32px;
                    .list{
                        height: 330px;
                        overflow-x: hidden;
                        &::-webkit-scrollbar {
                            display: none;
                        }
                        .item{
                            border-bottom: 1px solid #dadada;
                            padding: 14px 0;
                            letter-spacing: 1px;
                            line-height: 1.5;
                            .content{
                                margin-bottom: 10px;
                            }
                            .date{
                                color: #898989;
                            }
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 560px) {
        #modal.announcement{
            .modal-content{
                width: 90%;
                .detail{
                     >h1{
                        margin-bottom: 24px;
                        font-size: 20px;
                    }
                    .announcement-wrap{
                        .list{
                            height: 320px;
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/announcement.vue